import { Button, Grid2 } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useAdminApartmentList } from '../../assets/api/useAdminApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import useContactPersonStore from '../../store/useContactPersonStore'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { Grid_Gap, Input_Width } from '../../shared/constants'
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField'
import { TextFormField } from '../../shared/components/formfields/TextFormField'
import useAuthStore from '../../store/useAuthStore'
// import api from '../../assets/api/useStudentPostApi'
import CustomDivider from '../../shared/utils/CustomDivider'
import api from '../../assets/nodeApi/axiosInstance'

const CommoneEditStatusAparment = ({ id }) => {
    const { token } = useAuthStore()
    const queryClient = useQueryClient();
    const { data: apartmentlist, isLoading } = useAdminApartmentList()
    const matchedApartment = apartmentlist?.data?.find(item => item.id == id);
    const { showToaster } = useToaster();
    const validationSchema = Yup.object().shape({});
    const initialValues = {
        new_status: matchedApartment?.apartment_status || "",
        remarks: matchedApartment?.remarks || "",
    };

    const mutation = useMutation({
        mutationFn: (formData) => {
            return api.put(`apartment/update-status/${id}`, formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
        },
        onSuccess: (response) => {
            showToaster('Success', response?.data?.message, 'success')
            queryClient.invalidateQueries({ queryKey: ['get-all-apartments-list'] });
        },
        onError: () => {
            showToaster("Error Caught While submiting the form", 'Error', 'error');
        },
    });
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        mutation.mutate(values, {
            onSettled: () => {
                setSubmitting(false);
            },
            onSuccess: () => {
                resetForm();
            }
        });
    }
    const options = [
        {
            id: 1,
            value: "New",
            label: "New"
        },
        {
            id: 2,
            value: "Positive",
            label: "Positive"
        },
        {
            id: 3,
            value: "Inprogress",
            label: "Inprogress"
        },
        {
            id: 4,
            value: "Onboarded",
            label: "Onboarded"
        },
        {
            id: 5,
            value: "Not Interested",
            label: "Not Interested"
        },
        {
            id: 6,
            value: "Wrong Number",
            label: "Wrong Number"
        },
        {
            id: 7,
            value: "Call Back",
            label: "Call Back"
        },
    ]

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
        >
            {({ resetForm }) => (
                <Form>
                    <Grid2 container spacing={Grid_Gap}>

                        <Grid2 children size={Input_Width}>
                            <Field
                                name="new_status"
                                component={AutoCompleteField}
                                options={options}
                                label="Status"
                                type={"number"}
                            />
                        </Grid2>
                        <Grid2 children size={Input_Width}>
                            <Field
                                name="remarks"
                                component={TextFormField}
                                label="Remark"

                            />
                        </Grid2>

                    </Grid2>
                    <CustomDivider />
                    <Grid2 container spacing={Grid_Gap}>
                        <Grid2 children size={Input_Width}>
                            <Button variant='contained' type='submit' fullWidth>Edit</Button>
                        </Grid2>
                    </Grid2>
                </Form>
            )}
        </Formik>
    )
}

export default CommoneEditStatusAparment
